import { ProfSearch16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SummaryProfiessionalSearch.css';
export interface ISummaryProfiessionalSearchProps {
  link: string;
  onClick(): void;
}

export function SummaryProfiessionalSearch({ link, onClick }: ISummaryProfiessionalSearchProps) {
  return (
    <a className={styles['link']} href={link} onClick={onClick}>
      <ProfSearch16 color="primary_100" />
      Профпоиск
    </a>
  );
}

SummaryProfiessionalSearch.displayName = 'SummaryProfiessionalSearch';
